export const guideDetails2 = {
  'livestream-scraps': {
    slug: 'livestream-scraps',
    intro: '直播间里的「工厂直发」「边角料特价」有时确实划算，但更多时候是把规格、配料和保质期说得含糊。看货前先把这几项信息补齐。',
    riskNote: '食品类维权受时效与举证影响，收货后要尽快核对。',
    sections: [
      {
        heading: '「边角料」可能只是分装',
        paragraphs: [
          '所谓边角料，有时是大包装拆散分装的散装品，也可能是规格缩小后的正品。两者都没问题，但价格和净含量必须对得上。看清每克单价，再决定值不值。',
        ],
      },
      {
        heading: '配料表与生产信息要完整',
        paragraphs: [
          '正规预包装食品应标明配料、生产日期、保质期与生产者信息。缺项或模糊的，无论主播怎么保证，都建议换一家。',
          '直播口播与商品页不一致时，以商品页文字为准，并截图保留。',
        ],
      },
      {
        heading: '主播承诺不等于售后',
        paragraphs: [
          '「不好吃包退」这类口播如果不落到商品页的售后政策里，就很难兑现。下单前确认退换货规则，收货后留意保存温度与开封时间。',
        ],
      },
    ],
    signals: ['配料表与生产信息缺失', '口播与商品页描述不一致', '净含量与价格不成比例', '只强调味道不提保存条件'],
    checklist: ['核对配料表与生产信息', '计算每克或每份单价', '截图商品页保存描述', '确认退换货政策', '收货后尽快检查包装与日期'],
  },
  'near-expiry-food': {
    slug: 'near-expiry-food',
    intro: '临期食品能省钱，但「临期」和「过期」之间隔着一整套储存条件。不同品类能接受的剩余保质期差别很大。',
    riskNote: '风险主要来自储存不当导致的品质下降，注意收货后尽快食用。',
    sections: [
      {
        heading: '不同品类的安全窗口不同',
        paragraphs: [
          '保质期长、干燥密封的零食，剩余时间少一点通常影响不大；而乳制品、熟食、生鲜对温度敏感，剩余保质期过短就很容易在运输途中出问题。',
        ],
      },
      {
        heading: '收货后先看日期再决定囤多少',
        paragraphs: [
          '临期商品不要一次囤太多，尤其是保质期只剩几天的。按实际消耗速度购买，才是真正的省钱。',
        ],
      },
      {
        heading: '平台与商家的标识要看清',
        paragraphs: [
          '正规渠道会明确标注临期信息与剩余保质期。如果商家刻意淡化，甚至把临期当正常商品卖，可以要求退换并保留证据。',
        ],
      },
    ],
    signals: ['未标注剩余保质期', '生鲜与熟食剩余期过短', '包装有胀袋或渗漏', '冷链商品到手温度明显偏高'],
    checklist: ['选择保质期长且密封的品类', '确认剩余保质期是否够用', '按消耗速度购买不囤货', '收货后立即检查包装与日期', '冷链商品到手先测温度'],
  },
  'cheap-ticket-fees': {
    slug: 'cheap-ticket-fees',
    intro: '机票的价格由票面、行李、退改三部分组成。只比票面价，很容易在出发前被补差价和手续费反超。',
    riskNote: '临期改签费用可能远高于票面差价，务必提前确认。',
    sections: [
      {
        heading: '把行李额度折算成钱',
        paragraphs: [
          '廉价票往往不含托运行李。出发前单独购买行李额的价格，有时比含行李的票还贵。先估算行李需求，再比较总价。',
        ],
      },
      {
        heading: '退改规则决定这张票的弹性',
        paragraphs: [
          '特价票多数不可退或高额退。如果行程可能变化，宁可多花一点买弹性更好的票，也胜过临期付一笔改签费。',
        ],
      },
      {
        heading: '中转与到达时间也是成本',
        paragraphs: [
          '中转时间过短容易误机，到达时间太晚则增加一晚住宿与交通成本。把落地后的接驳费用算进去，才是真实出行成本。',
        ],
      },
    ],
    signals: ['票面价明显低于同航线均价', '不含托运行李且未提示', '中转时间不足九十分钟', '退改费用说明模糊'],
    checklist: ['估算行李并比较总价', '确认退改规则与费用', '检查中转时间是否充裕', '评估落地后的接驳成本', '保留订单与规则截图'],
  },
  'homestay-photo-tricks': {
    slug: 'homestay-photo-tricks',
    intro: '民宿照骗的核心是「拍摄方式」而非「虚假照片」。用地图、评价和细节图交叉验证，能过滤掉大部分货不对板的房源。',
    riskNote: '旺季取消与差价损失较大，尽量选择可免费取消的房型。',
    sections: [
      {
        heading: '广角与样板间是两大信号',
        paragraphs: [
          '室内照片使用超广角时，房间会显得比实际大很多。留意家具比例与门框是否明显变形，能大致判断拍摄视角。',
          '如果多套房源使用同一批精修图，很可能是统一运营的样板展示，实际房源需要看用户实拍。',
        ],
      },
      {
        heading: '位置一定要在地图上核对',
        paragraphs: [
          '把房源地址放到地图里查看周边，能快速识破「靠近地铁」却要步行二十分钟的情况。描述含糊、不愿给具体定位的，要格外小心。',
        ],
      },
      {
        heading: '看差评比看好评更有用',
        paragraphs: [
          '重点看中差评里反复出现的问题：隔音、热水、清洁、房东响应速度。同一问题被多人提起，就是真实短板。',
        ],
      },
    ],
    signals: ['多套房源使用相同精修图', '位置描述含糊不下定位', '好评高度雷同', '中差评集中在同一问题'],
    checklist: ['在地图上核对实际位置', '查看房间实拍而非精修图', '重点阅读中差评内容', '确认取消与退款政策', '入住当天先验房再确认'],
  },
  'guaranteed-pass-contract': {
    slug: 'guaranteed-pass-contract',
    intro: '「保过班」的承诺通常附带大量前置条件。真正的风险不在宣传语，而在合同里那一长串退费与出勤条款。',
    riskNote: '金额较大，若涉及分期付款，退费争议会更复杂。',
    sections: [
      {
        heading: '保过的前提条件往往很苛刻',
        paragraphs: [
          '常见的附加条件是：全勤、完成全部作业、达到某次模拟考分数。任何一条不满足，保过承诺即失效。签字前先把这些条件找出来。',
        ],
      },
      {
        heading: '退费条款要看清楚',
        paragraphs: [
          '退费比例、申请时限、扣除项目都需要明确。口头承诺的「随时可退」如果没有写进合同，很难作为依据。',
          '课程分期如果通过第三方金融产品办理，退课时可能涉及还款与征信问题，务必问清。',
        ],
      },
      {
        heading: '试听与实际师资要一致',
        paragraphs: [
          '确认授课老师是否就是试听时的老师，课时数、班级规模是否写明。对「名师授课」这类表述，要求落到合同的具体安排里。',
        ],
      },
    ],
    signals: ['只口头承诺保过不写进合同', '退费条款含糊或设置高门槛', '引导办理第三方分期', '试听师资与正式课程不一致'],
    checklist: ['逐条阅读保过的前提条件', '确认退费比例与申请时限', '问清分期与征信影响', '核对师资与课时是否写明', '保留宣传页面与合同副本'],
  },
  'repair-price-double': {
    slug: 'repair-price-double',
    intro: '上门维修的价格争议，多半不是修不好，而是没提前说清。叫师傅前把报价方式、配件来源、保修期问明白，能省掉一大半扯皮。',
    riskNote: '现场加价较难反悔，建议先确认报价再让师傅动手。',
    sections: [
      {
        heading: '先问计价方式再约上门',
        paragraphs: [
          '是上门费 + 材料费，还是一口价？上门费是否可抵扣维修费？把计价方式说在前面，能避免「到场后才知道」的被动。',
        ],
      },
      {
        heading: '「原厂配件」需要有依据',
        paragraphs: [
          '原厂配件通常有包装、编码或进货凭证。仅凭口头保证就多收数倍价格，值得多问一句。要求查看配件包装并保留旧件，是简单有效的做法。',
        ],
      },
      {
        heading: '维修后要保修凭证',
        paragraphs: [
          '正规维修会提供一定期限的保修。更换了哪些部件、保修多久、如何联系，都应写在单据上。没有凭证的维修，出了问题很难追责。',
        ],
      },
    ],
    signals: ['到现场才报出高额费用', '只口头强调「原厂配件」', '拒绝提供维修单据', '要求先付款再检修'],
    checklist: ['提前确认计价方式与上门费', '要求查看配件包装并保留旧件', '索取写明保修期的单据', '对比官方售后报价', '大额维修前多问一家'],
  },
};